/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientWorkspaceSettings = sqliteTable('patient_workspace_settings', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  workspace_mode: text('workspace_mode'),
  show_treatment_record: integer('show_treatment_record'),
  show_patient_timeline: integer('show_patient_timeline'),
  default_sidebar_state: text('default_sidebar_state'),
  sidebar_show_overview: integer('sidebar_show_overview'),
  sidebar_show_intake_form: integer('sidebar_show_intake_form'),
  sidebar_show_vitals: integer('sidebar_show_vitals'),
  sidebar_show_allergies: integer('sidebar_show_allergies'),
  sidebar_show_visits: integer('sidebar_show_visits'),
  sidebar_show_treatment_record: integer('sidebar_show_treatment_record'),
  sidebar_show_contact: integer('sidebar_show_contact'),
  sidebar_show_pharmacy: integer('sidebar_show_pharmacy'),
  consult_show_summary: integer('consult_show_summary'),
  consult_show_vitals: integer('consult_show_vitals'),
  consult_show_charting: integer('consult_show_charting'),
  consult_show_notes: integer('consult_show_notes'),
  consult_show_prescriptions: integer('consult_show_prescriptions'),
  consult_show_treatment_plan: integer('consult_show_treatment_plan'),
  consult_show_forms: integer('consult_show_forms'),
  consult_show_files: integer('consult_show_files'),
  consult_show_invoices: integer('consult_show_invoices'),
  consult_show_payments: integer('consult_show_payments'),
  treatment_record_drawer_width: text('treatment_record_drawer_width'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
